import { useMemo } from "react";
import { sharedEnvironment } from "../../config";
import { useAuth } from "../../infra";
import { useLocaleStore } from "../../presentation";
import { configureApi } from "./index";

export const useApi = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth();
  const locale = useLocaleStore(state => state.locale);

  const apiConfigCreation = useMemo(
    () => ({
      baseUrl: sharedEnvironment.apiBaseUrl,
      getAccessToken: isAuthenticated ? getAccessTokenSilently : undefined,
      locale,
      cmsLinkWithEnv: sharedEnvironment.cmsLinkWithEnv,
    }),
    [locale, getAccessTokenSilently, isAuthenticated],
  );

  const api = useMemo(() => configureApi(apiConfigCreation), [apiConfigCreation]);

  return { api };
};
